import {loaderReducer} from 'src/app/store/reducers/loader.reducer';

export const reducers = {
   loader: loaderReducer
};
